import type {
  AddressRetrieveDetail,
  AddressRetrieveFormFields,
} from '../../../core/models/address-retrieve';

/**
 * Maps GET /addresses/retrieve details to ship-from-ship-to address form fields.
 * Matches ESN AddressComplete retrieve population: Line1 → street, Line2 → suite,
 * City / ProvinceCode / PostalCode. Does not use SubBuilding (unit is usually
 * already embedded in Line1, e.g. "123-10 Empringham Dr").
 * Sets residential from Canada Post type === 'Residential' for AVS validate.
 */
export function mapAddressRetrieveDetailToFormFields(
  detail: AddressRetrieveDetail,
): AddressRetrieveFormFields {
  const streetAddress = detail.line1.trim() || detail.street.trim();
  const province = detail.provinceCode.trim() || detail.province.trim();

  return {
    streetAddress,
    suiteAptUnit: detail.line2.trim(),
    city: detail.city.trim(),
    province: province.length > 0 ? province : null,
    postalCode: detail.postalCode.trim(),
    residential: detail.type === 'Residential',
  };
}
